import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { AuthService } from './auth.service';

/** Route guard: session + `data.role` (delegates to `AuthService.checkUserRole`). */
export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  return auth.checkUserRole(route, state.url);
};
